import React from "react";
import {Route, Routes} from "react-router-dom";
import CreateStatisticsCategory from "../container/statistics/CreateStatisticsCategory";
import StatisticsList from "../container/statistics/StatisticsList";
import UpdateStatisticsCategory from "../container/statistics/UpdateStatisticsCategory";
import UpdateItem1 from "../container/statistics/UpdateItem1";
import CreateItem1 from "../container/statistics/CreateItem1";
import UpdateItem2 from "../container/statistics/UpdateItem2";
import CreateItem2 from "../container/statistics/CreateItem2";

const Statistics = () => {
  return (
    <Routes>
      <Route path="/*" element={<StatisticsList />} />
      <Route path="CreateCategory" element={<CreateStatisticsCategory />} />
      <Route path="EditCategory/:id" element={<UpdateStatisticsCategory />} />
      <Route path="EditItem1/:id" element={<UpdateItem1 />} />
      <Route path="CreateItem1/:id" element={<CreateItem1 />} />
      <Route path="EditItem2/:id" element={<UpdateItem2 />} />
      <Route path="CreateItem2" element={<CreateItem2 />} />
    </Routes>
  );
};

export default Statistics;
